import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import { operations, selectors } from './../ducks/group-details';

class GroupsEnabledContainer extends Component {
  componentDidMount() {
    const { initializeOrganizationSettings, loading } = this.props;

    if (loading) {
      initializeOrganizationSettings();
    }
  }

  render() {
    const {
      children,
      groupsEnabled,
      loading,
    } = this.props;

    return (
      <ContentLoader show={loading}>
        {groupsEnabled ? (
          children
        ) : (
          <Redirect to="/team-management" />
        )}
      </ContentLoader>
    );
  }
}

GroupsEnabledContainer.propTypes = {
  children: PropTypes.node.isRequired,
  groupsEnabled: PropTypes.bool,
  initializeOrganizationSettings: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

GroupsEnabledContainer.defaultProps = {
  groupsEnabled: false,
};

const mapDispatchToProps = {
  initializeOrganizationSettings: operations.initializeOrganizationSettings,
};

export default connect(selectors.groupsEnabledSelector, mapDispatchToProps)(
  GroupsEnabledContainer,
);
export { GroupsEnabledContainer };
